import React from "react";
import { Subheading } from "../../../design/heading";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../design/table";
import FileActionButtons from "../../../components/FileActionButtons";
import UploadFileButton from "./UploadChildFileButton";
import DeleteFileButton from "./DeleteChildFileButton";
import { useChild } from "../../../contexts/ChildContext";
import FilesLearnMore from "../../../components/LearnMores/FilesLearnMore";

interface Props {
  childId: string;
}

const ChildDetailFileList: React.FC<Props> = ({ childId }) => {
  const { files } = useChild();
  return (
    <>
      <div className="flex flex-wrap items-end justify-between w-full">
        <div className="flex items-center gap-1 mt-12">
          <Subheading>Files</Subheading>
          <FilesLearnMore type="child" />
        </div>
        <div className="flex gap-4">
          <UploadFileButton childId={childId} />
        </div>
      </div>
      {files.length === 0 && (
        <div className="mt-8 text-center">
          <Subheading>No Files found</Subheading>
        </div>
      )}
      {files.length > 0 && (
        <Table className="mt-4 [--gutter:theme(spacing.6)] lg:[--gutter:theme(spacing.10)]">
          <TableHead>
            <TableRow>
              <TableHeader>File</TableHeader>
              <TableHeader>Description</TableHeader>
              <TableHeader className="text-right" />
            </TableRow>
          </TableHead>
          <TableBody>
            {files.map((file) => (
              <TableRow
                key={file.id}
                title={`Visit #${file.id}`}
                href={`/file/${file.id}`}
              >
                <TableCell>{file.name}</TableCell>
                <TableCell>{file.description}</TableCell>
                <TableCell className="flex items-end justify-end gap-2">
                  <FileActionButtons path={file.path} />
                  <DeleteFileButton childId={childId} file={file} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </>
  );
};

export default ChildDetailFileList;
